import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

// Logos (replace with your actual images)
import airbnb from "../../Assests/pinterest.svg";
import stripe from "../../Assests/pinterest.svg";
import unsplash from "../../Assests/pinterest.svg";
import freepik from "../../Assests/pinterest.svg";
import pinterest from "../../Assests/pinterest.svg";
import huawei from "../../Assests/pinterest.svg";
import linkedin from "../../Assests/pinterest.svg";

const logos = [airbnb, stripe, unsplash, freepik, pinterest, huawei, linkedin];

const HeroSection = () => {
    return (
        <Box
            sx={{
                
                py: 6,
               pt:16,
                position: "relative",
                overflow: "hidden",
                minHeight: "auto",
            }}
        >
            <Container maxWidth="lg" sx={{ textAlign: "center", pt: 4 }}>
                {/* Top Label */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        fontSize: "21px",
                        color: "#007BFF",
                        mb: 1,
                    }}
                >
                    Developer Documentation
                </Typography>

                {/* Main Heading */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 590,
                        fontSize: { xs: "30px", md: "48px" },
                        lineHeight: { xs: "36px", md: "56px" },
                        color: "#1A202C",
                        mb: 4,
                    }}
                >
                    Showcase reliability, scalability,<br />
                    and ease of integration.
                </Typography>

                {/* CTA Button */}
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#10B981",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 500,
                        px: "30px",
                        py: "8px",
                        borderRadius: "10px",
                        border: "1px solid #10B981",
                        "&:hover": {
                            backgroundColor: "#0ea97d",
                        },
                        mb: 14,
                    }}
                >
                    View Demo
                </Button>

                {/* Partner Logos */}
                <Typography variant="subtitle1" sx={{ mb: 0.5, color: "#d4d5d6" }}>
                    Trusted by 100+ businesses
                </Typography>

                <Box sx={{ position: "relative", width: "100%", maxWidth: '900px', margin: '0 auto', mt: 2 }}>
                    {/* Left Fade Overlay */}
                    <Box
                        sx={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "200px",
                            background:
                                "linear-gradient(90deg, #f8f8f8 0%, #f8f8f8 30%, rgba(255,255,255,0.1) 80%, transparent 100%)",
                            zIndex: 2,
                        }}
                    />

                    {/* Right Fade Overlay */}
                    <Box
                        sx={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            height: "100%",
                            width: "200px",
                            background:
                                "linear-gradient(270deg, #f8f8f8 0%, #f8f8f8 30%, rgba(255,255,255,0.1) 80%, transparent 100%)",
                            zIndex: 2,
                        }}
                    />

                    {/* ✅ Swiper v12+ Continuous Auto Scroll Carousel */}
                    <Swiper
                        modules={[Autoplay]}
                        spaceBetween={20}
                        slidesPerView={5}
                        loop={true}
                        autoplay={{
                            delay: 0, // No delay - continuous scroll
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                            stopOnLastSlide: false,
                        }}
                        speed={5000} // Adjust this value for scroll speed (higher = slower)
                        freeMode={true} // Enable free mode for smooth continuous scroll
                        freeModeMomentum={false} // Disable momentum to keep steady speed
                        allowTouchMove={false} // Disable manual drag for pure auto-scroll
                        style={{
                            width: "100%",
                            padding: "20px 0",
                            transitionTimingFunction: "linear", // Linear animation for constant speed
                        }}
                        breakpoints={{
                            320: { slidesPerView: 2, spaceBetween: 20 },
                            480: { slidesPerView: 3, spaceBetween: 30 },
                            768: { slidesPerView: 4, spaceBetween: 30 },
                            1024: { slidesPerView: 5, spaceBetween: 30 },
                            1200: { slidesPerView: 6, spaceBetween: 30 },
                            1440: { slidesPerView: 7, spaceBetween: 30 },
                        }}
                    >
                        {logos.map((logo, index) => (
                            <SwiperSlide key={index}>
                                <Box
                                    component="img"
                                    src={logo}
                                    alt={`Partner logo ${index + 1}`}
                                    sx={{
                                        height: "30px",
                                        width: "auto",
                                        objectFit: "contain",
                                        mx: "auto",
                                        filter: "grayscale(100%)",
                                        opacity: 0.7,
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            filter: "grayscale(0%)",
                                            opacity: 1,
                                        },
                                    }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>
            </Container>
        </Box>
    );
};

export default HeroSection;
